import { Pipe, PipeTransform } from '@angular/core';
import Helpers from '../../helpers';

@Pipe({ name: 'dateBasic' })
export class DateBasicPipe implements PipeTransform {
  transform(value: any): string {
    return Helpers.getDateString(value);
  }
}
